// /Users/donovan68/dva-frontend-vite/src/components/Step3TabNav.tsx
import { Link, useLocation } from 'react-router-dom';

interface Step3TabNavProps {
  className?: string;
}

const tabs = [
  {
    id: 'roadmap',
    label: 'Roadmap',
    path: '/pro/roadmap-planning',
    description: 'Multi-use-case implementation timeline'
  },
  {
    id: 'approval',
    label: 'Approval',
    path: '/pro/approval',
    description: 'Governance workflow and strategic sign-off'
  },
  {
    id: 'execution',
    label: 'Execution',
    path: '/pro/execution',
    description: 'Deploy dashboards and track adoption'
  },
  {
    id: 'resources',
    label: 'Resources',
    path: '/pro/resources',
    description: 'Implementation resources, playbooks, and tools'
  }
];

export function Step3TabNav({ className = '' }: Step3TabNavProps) {
  const location = useLocation();

  // Determine active tab based on current path
  const activeTabId = tabs.find(tab => 
    location.pathname.startsWith(tab.path)
  )?.id || 'approval';

  return (
    <div className={`bg-white border-b border-[#e5e7eb] ${className}`}>
      <div className="max-w-[1440px] mx-auto px-6">
        <nav className="flex items-center gap-1" aria-label="Step 3 Navigation">
          {tabs.map((tab) => {
            const isActive = activeTabId === tab.id;
            
            return (
              <Link
                key={tab.id}
                to={tab.path}
                className={`
                  relative px-6 py-3 text-sm font-semibold transition-all duration-200
                  ${isActive 
                    ? 'text-[#FF6E4C]' 
                    : 'text-[#717182] hover:text-[#18365E]'
                  }
                `}
                aria-current={isActive ? 'page' : undefined}
              >
                {tab.label}
                
                {/* Active tab indicator */}
                {isActive && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-[#FF6E4C] animate-pulse" />
                )}
              </Link>
            );
          })}
        </nav>
      </div>
    </div>
  );
}